<template>
  <div
    :class="['page-wrapper', (regulated) ? 'regulated' : '' ,(flexGrow) ? 'flex-grow': '']"
    ref="_page_wrapper"
    :style="PAGE_HEIGHT"
  >
    <slot></slot>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";

const $props = defineProps(["regulated","flexGrow"])
const _page_wrapper = ref(null)

const PAGE_HEIGHT = computed(() => {

  if ($props.regulated) {
    let top_space = _page_wrapper.value?.getBoundingClientRect().top + window.scrollY

    return {
      "--page-height-mod": `${top_space}px`
    }
  }
})
</script>

<style lang="scss" scoped>
  .page-wrapper {
    padding: 16px 32px;
    display: flex;
    flex-direction: column;

    @include screenM {
      padding: 12px;
    }

    @include screenS {
      padding: 24px;
    }

    &.regulated {
      overflow: hidden;
      height: calc(100vh - var(--page-height-mod));

      @include screenL {
        padding: 16px 0;
      }

      @include screenM {
        padding: 12px 0;
      }

      @include screenS {
      padding: 16px 0;
      } 
    }
  }
  .flex-grow {
    flex: 1 1 auto;
  }
</style>